import { buildUserIdPayload } from '../utils/userIdPayload';
import { getNativePlatformAuth } from '../utils/platformAuth';

async function trackingRequest(operation, { platform, userId, signal, ...body }) {
    const auth = getNativePlatformAuth();
    const response = await window.fetch(`${process.env.REACT_APP_API_URL || ''}/api/tracking/${operation}`, {
        method: 'POST', signal,
        headers: { 'Content-Type': 'application/json', 'X-Platform': auth.platform || platform,
                   'X-Platform-Init-Data': auth.initData || '' },
        body: JSON.stringify({ ...body, ...buildUserIdPayload(platform, userId) }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.detail || 'Не удалось обновить данные СДЭК');
    return result;
}

export const startTrackingList = (body) => trackingRequest('start-list', body);
export const readTrackingPage = (body) => trackingRequest('read-page', body);
export const searchTracking = (body) => trackingRequest('search', body);

export const getTrackingCard = (body) => trackingRequest('get_package_info', body);
export const sendTrackingDocument = (kind, body) => trackingRequest(`send/${kind}`, body);
